import _ from "lodash";
import Indicador from "..";
import EditFields from "./components/EditFields";
import { ParamFields } from "./components/ParamFields";
import ReportSummary from "./reports/summary";

import apontamentoReport from "./reports/index";



export default class ADO extends Indicador {
    static get fullName() {
        return "Aferição de Dosagem de Óxido";
    }

    static get abbrev() {
        return "ADO";
    }

    static get field() {
        return "ado";
    }

    static get multTipo() {
        return true
    }

    static get legacyApontamentoMap() {
        return {
            dataHora: {
                newField: "date",
                convert: this.parseLegacyDate,
            },

            tipo: "tipo",
            talhao: "talhao",
            trator: "trator",
            implemento: "implemento",
            frente: "frente",


            insumo: "insumo",
            dosagemRecomendada: "dosagemRecomendada",


            coletas: {
                type: Array,
                newField: "coletas",
                children: {
                    pesagem: "pesagem",
                    observacaoColeta: "observacao",
                    foto: {
                        newField: "image.uid",
                        convert: this.convertLegacyImageUid,
                    },
                    confirmaRelatorio: "confirmaRelatorio",
                    "foto.georeferencia": "georeferencia",
                    georeferencia: "georeferencia",
                },
            },

            conformidadeAmostra: "conformidade",
            afericao: "afericao",
            mediaColetas: "media",
            dosePorMetro: "doseMetro",

            observacaoAmostra: "observacao",

            itensColeta: "images",
        };
    }

    static get legacyParamMap() {
        return {
            intervaloMinDosagemOxidoManual: "manual.intervaloMin",
            intervaloMaxDosagemOxidoManual: "manual.intervaloMax",
            metrosLinearesAmostraDosagemOxidoManual: "manual.metrosLinearesAmostra",
            metrosLinearesHectaresDosagemOxidoManual: "manual.metrosLinearesHectare",
            metaDosagemOxidoManual: "manual.meta",

            intervaloMinDosagemOxidoMecanizado: "mecanizado.intervaloMin",
            intervaloMaxDosagemOxidoMecanizado: "mecanizado.intervaloMax",
            metrosLinearesAmostraDosagemOxidoMecanizado: "mecanizado.metrosLinearesAmostra",
            metrosLinearesHectaresDosagemOxidoMecanizado: "mecanizado.metrosLinearesHectare",
            metaDosagemOxidoMecanizado: "mecanizado.meta",
        };
    }

    static paramFields(tipoIndicadorField = '') {
        return <ParamFields tipoIndicadorField={tipoIndicadorField} />
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <EditFields visita={visita} TipoClass={TipoClass} />
    }

    async renderReport(visita) {
        return apontamentoReport(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return ReportSummary(this, visita, tipoName);
    }

    static calcConformidade(apontamento, params) {
        const f = parseFloat;

        if (!apontamento.coletas || !params || apontamento.coletas.length === 0) {
            return 0;
        }

        const total = apontamento.coletas.length;
        let sumPesagem = 0;

        for (const coleta of apontamento.coletas) {
            if (coleta.pesagem) {
                sumPesagem += f(coleta.pesagem);
            }
        }

        apontamento.media = sumPesagem / total;
        apontamento.media = apontamento.media.toFixed(4);

        // Dose por metro linear média das coletas.
        apontamento.doseMetro = apontamento.media / f(params.metrosLinearesAmostra);
        apontamento.doseMetro = apontamento.doseMetro.toFixed(4);

        apontamento.afericao = apontamento.doseMetro * f(params.metrosLinearesHectare);
        apontamento.afericao = apontamento.afericao.toFixed(4);

        const dosagemRecomendada = f(apontamento.dosagemRecomendada);

        if (!_.isNaN(dosagemRecomendada)) {
            const rawConformidade = (apontamento.afericao / f(apontamento.dosagemRecomendada)) * 100;
            apontamento.acima = rawConformidade > f(params.intervaloMax) ? 1 : 0;
            apontamento.abaixo = rawConformidade < f(params.intervaloMin) ? 1 : 0;
            let conformidade = rawConformidade > 100 ? rawConformidade - 200 : rawConformidade;

            return Math.abs(conformidade).toFixed(2);
        } else {
            apontamento.acima = 0;
            apontamento.abaixo = 0;
            return 0;
        }
    }

    static getConformidadeStatus(conformidade, meta) {

        if (conformidade > 100) {
            return "Ruim";
        }
        if (conformidade === 100) {
            return "Ótimo";
        }
        if (conformidade > meta) {
            return "Bom";
        }
        if (conformidade > meta - 15) {
            return "Regular";
        }
        return "Ruim";

        // const calcConformidadeStatus3 = (conformidade, meta, minRegular, minBom, minOtimo) => {

        //     if (!_.isNaN(conformidade)) {
        //         if (conformidade >= minOtimo) {
        //             return "Ótimo";
        //         } else if (conformidade >= minBom) {
        //             return "Bom";
        //         } else if (conformidade >= minRegular) {
        //             return "Regular";
        //         } else {
        //             return "Ruim";
        //         }
        //     }
        // }
        // return calcConformidadeStatus3(conformidade, meta, 94.73, 100, 103.15);
    }


    static getResultStr(apontamento) {
        return "Afericao: " + apontamento.afericao +
            ", Média: " + apontamento.media +
            " e Dose/M: " + apontamento.doseMetro
    }
}
